import React, { useState, useEffect } from "react";
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { getRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";

import {LOADING} from "../../action/index";
import {useSelector, useDispatch} from 'react-redux';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontWeight: "bold",
        border: 0,
        paddingTop: 0,
       paddingBottom: 0
    }
  }))(TableCell);
  
const StyledTableBodyCell = withStyles((theme) => ({
    root:{
        color: "#979797",
        border:0,   
         paddingTop: 0,
        paddingBottom: 0
    }
  }))(TableCell);
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
      },
    contractMenu:{
        fontSize: 18,
        cursor:"pointer",
    },
    active:{
        color:"#ff4717",
      },
    tableLayout:{
        border:0,
        boxShadow: "0 0 0 0 !important"
    }
}));
export default function SalesAgreementLines(props) {
    const { rows, onActiveKey } = props;
    const [contractListItems, setContractListItems] = useState([]);
    const classes = useStyles();
    const dispatch = useDispatch();
    
    ////console.log(rows,'Item',onActiveKey);
    useEffect(() => {
        if(onActiveKey == 'SalesAgreementLines') getSalesAggrement(rows.contractKey);
    }, []);
    
    const getSalesAggrement = (contractKey) =>{
        dispatch({type:LOADING, payload: true});
        ////console.log(rows,'Item1',onActiveKey);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Contract/SalesAggrement/${contractKey}`;
        getRequest(url)
        .then((res) => {
          ////console.log(res);
          if (res.status == 200) {
            dispatch({type:LOADING, payload: false});
            setContractListItems(res.data);
          } else {
            dispatch({type:LOADING, payload: false});
            ToastError(res.data.message);
          }
        })
        .catch((error) => {
            dispatch({type:LOADING, payload: false});
          ////console.log(error.response);
          // ToastError(error.response.data.message);
          ToastError("Try again after some time or contact your help desk");
        });
    }
    return (
        <React.Fragment>
            <TableContainer component={Paper} className={classes.tableLayout} >
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <StyledTableCell>ITEM No</StyledTableCell>
                        <StyledTableCell>ITEM/CATEGORY NAME</StyledTableCell>
                        <StyledTableCell align="center">QUANTITY</StyledTableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {contractListItems.length?contractListItems.map((row) => (
                        <TableRow >
                        <StyledTableBodyCell >{row.itemNo}</StyledTableBodyCell>
                        <StyledTableBodyCell >{row.categoryName}</StyledTableBodyCell>
                        <StyledTableBodyCell  align="center">{row.quantity}</StyledTableBodyCell>
                        </TableRow>
                        )):""}
                    </TableBody>
                    <TableBody>
                        {!contractListItems.length?(
                        <TableRow >
                        <StyledTableBodyCell colSpan="3" style={{textAlign:"center"}} >No data found</StyledTableBodyCell>
                        </TableRow>
                        ):""}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    )
}
